var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mx-auto",attrs:{"color":"light-blue","text":""},on:{"click":_vm.chatWithUs}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-chat")]),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.$t("s1656805768")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }